export const patient=[
    {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
     {
        name:"Subodh Roy",
        Age:45,
        Address:"123, Abc Road ,Kalyani,Nadia",
        AssignedDoc:["Dr. Albert Einstein","Dr. Issac Newton"],
        registered:'01-06-2020',
        disease:["Fever","Cancer","Thyroids"]

    },
]